import './services/static-data.service';
import { StaticDataService } from './services/static-data.service';


// Force side-effect usage
console.log('StaticDataService initialized', StaticDataService.UNITED_STATES);
